<generic-chart *ngIf="series_ready" [config]="config" style="height:100%;width:100%"></generic-chart>